import { Injectable } from '@angular/core';
import { Paginator } from '@app/shared/models/paginator/paginator';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})

export class AuxiliarService {

  constructor() { }
  getBoolean(value){
    switch(value){
         case true:
         case "true":
         case 1:
         case "1":
         case "on":
         case "yes":
             return true;
         default: 
             return false;
     }
  }

  convertirBooleanApi(value){
    switch(value){
         case true:
         case "true":
         case 1:
         case "1":
         case "on":
         case "yes":
             return 1;
         default: 
             return 0;
     }
  }

  extraerFiltrosPaginacion( paginator?: Paginator ) {
    let params = `numeroElementosPaginador=`;
    if ( paginator?._numeroElementosPagina !== undefined ) {
      params =  `numeroElementosPaginador=${ paginator?._numeroElementosPagina }`;
      params       += `&pagina=${ paginator?._pagina  + 1 }`;
    }
    return params;
  }

  extraerFiltros( filtros: any) {
    let params = '';
    for (const property in filtros) {
      params +=  ( filtros[property] && filtros[property].length ) ? `&${property}=${filtros[property]}`: '';
    }
    return params;
  }

  filtrosDefecto(filtros?: any) {
    let _filtros = filtros;
    if(!_filtros) {
      _filtros = { orden: 'identificador', tipoOrden: 'asc', numeroElementosPaginador: environment.numeroElementosPaginador, pagina: 1 };
    } else {
      if(!_filtros.orden) {
        _filtros = { ..._filtros, orden: 'identificador', tipoOrden: 'desc' };
      }
      if(!_filtros.numeroElementosPaginador) {
        _filtros = {..._filtros, numeroElementosPaginador: environment.numeroElementosPaginador, pagina: 1};
      }
    }
    return _filtros;
  }
  
  today() {
    let date = new Date()
    let day = date.getDate()
    let month = date.getMonth() + 1
    let year = date.getFullYear()

    if(month < 10){
      return `${day}/0${month}/${year}`;
    }else{
      return `${day}/${month}/${year}`;
    }
  }


  convertirDateEs(fecha: string): Date {
    let dateParts: number[] = fecha.split("/").map(item => parseInt(item));
    let dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
    return new Date(dateObject);
  }

  busquedaPropiedad( elementos, propiedad, valor ) {
    return  elementos.find(element => element[propiedad] === valor );
  }

  buscarObjetosArrayByValorAtributo( elementos, propiedad, valor ): object [] {
    const elementosFiltrados = [];
    if (elementos && elementos.length) {
      elementos.forEach(element => {
        if ((element[propiedad].toUpperCase()).includes(valor.toString().toUpperCase())) {
          elementosFiltrados.push(element);
        }
      });
    }
    return elementosFiltrados;
  }

 buquedaPosicionPropiedad( elementos, propiedad, valor ): number {
  console.log(propiedad, valor);
  return  elementos.findIndex(element => element[propiedad] === valor );
}

  reemplazarComillas ( texto: string ): string {
    let texto2 = texto.replace('"', '\"');
    return texto2;
  }

  convertTZ(date, tzString="Europe/Madrid") {
    return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-ES", {timeZone: tzString}));   
  }


  calcularDiaLaborable(diaPedido, diasPactados) {
    const festivos = [[1, 7, 8],[27, 28],[1],[6, 9],[1],[15],[9],[17, 18, 19],[10],[12, 23],[],[25]];
    // diaPropuesto: almacena el mismo valor de diaPedido, en caso que diasPactados = 0, la función 
    // devolverá el valor de diaPedido (para mi tiene lógica)
    let diaPropuesto = new Date(diaPedido.getFullYear(), diaPedido.getMonth(), diaPedido.getDate());

    // iniciamos un contador en 1 para calcular la fecha de diaPropuesto.
    let i = 1;
    
    // El siguiente bucle se ejecutará hasta que se consuman los diasPactados
    while (diasPactados > 0 ) {
        // En cada iteración asumimos que el día no es festivo
        let festivo = false;
        // incrementamos en 1 el diaPropuesto para efectuar las verificaciones
        diaPropuesto = new Date(diaPedido.getFullYear(), diaPedido.getMonth(), diaPedido.getDate() + i);
        // Nótese que usamos formato ISO y solo incrementamos el día, dejando el mes y el año iguales
        // Alguien preguntará: ¿Y que pasa si la fecha es, digamos, 31 de Enero y le aumentamos 1 día?
        // Pues la respuesta lógica es que daría 32 de Enero, lo cual no es una fecha válida.
        // Sin embargo, JavaScript es un poco mas atento que nosotros y simplemente realiza la aritmética
        // necesaria para convertir el 32 de Enero en 01 de Febrero, y así nos salva el pellejo.
        // Véase bien que usamos los métodos getFullYear(), getMonth() y getDate().
        // Esto funciona siempre y cuando hagamos la construcción del objeto Date de esta manera.
        // Ya irá alguno de avispado y pondrá: fecha = new Date('2019-01-32'); lo cual le dará 'fecha inválida'
        // Alguien un poco mas versado puede aclarar este asunto, pero no es el objetivo en este momento.

        if (diaPropuesto.getDay() > 0 && diaPropuesto.getDay() < 6) {
            // Aquí hemos usado el método getDay() del objeto Date, este método devuelve un valor entero entre 0 y 6,
            // donde 0: Domingo, 1: Lunes, ... , 6: Sabado.
            // Los días laborables van del 1 al 5 (ambos inclusive)
            
            // Si el día es laborable debemos entonces verificar si es festivo
            
            // Aquí es importante que entendamos lo siguiente:
            //  * Por cada iteración debemos obtener el mes en el que estamos comprobando el festivo
            //  * Vamos a comparar el día propuesto con el Array de festivos, usando el mes correspondiente

            let m = diaPropuesto.getMonth();
            let dia = diaPropuesto.getDate();

            // Felizmente para nosotros el método getMonth() devuelve un entero entre 0 y 11, que se
            // corresponde con cada mes del año, y digo felizmente, porque los índices de nuestro Array
            // van de 0 a 11 también.

            for (let d in festivos[m]) {
                if (dia === festivos[m][d]) {
                    festivo = true;
                    //Aquí no hay mucho que aclarar, si es festivo ya no sigo comprobando el resto del mes.
                    break;
                }
            } // Fin bucle for

            if (!festivo) {
                // Si las condiciones son: Laborable y No Festivo, descuento el diaPactado.
                diasPactados--;
            }
        }

        // Por último, debemos incrementar el número de días que sumaremos al diaPropuesto
        // en cada iteración
        i++;
    } // Fin de bucle while

    // Devolvemos el resultado
    return diaPropuesto;
  }

  filtrarParametros (entrada: any, parametrosPeticion: any) {
    let parametros : Object = new Object();
    parametrosPeticion.forEach(item => {
      if (entrada[item]) {
        parametros[item] = entrada[item];
        // Object.defineProperty(parametros, item, {
        //   value: entrada[item]
        // });
      }
    });
    return parametros;
  }

  ordenarArrayObjetosByAtributo(array: any[], atributo: string) {
    return array.sort((a, b) => {
      if (!isNaN(Number(a[atributo]))) {
        return Number(a[atributo]) < Number(b[atributo]) ? -1 : Number(a[atributo]) > Number(b[atributo]) ? 1 : 0;
      } else {
        return a[atributo] < b[atributo] ? -1 : a[atributo] > b[atributo] ? 1 : 0;
      }
    });
  }

  intercambiarObjetoArrays(arrayOrigen: any, arrayDestino: object[], elemento: object) {
    const posicionBorrado = arrayOrigen.indexOf(elemento);
    if ( posicionBorrado !== -1 ) {
      arrayOrigen.splice( posicionBorrado, 1 );
      arrayDestino.push(elemento);
    }

    const result = [arrayOrigen, arrayDestino];
    return result;
  }

  copiarArrayObjetosSinReferencia(arrayOriginal: object []): object[] {
    return arrayOriginal.map(row => ({ ...row }));
  }

  formatBytes(bytes, decimals  = 2) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }


  eliminarEspaciosEnBlancoString(texto: string): string {
    return texto.replace(/\s+/g, '').trim();
  }

  eliminarTildes(texto: string): string {
    return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  patternEmail() {
    return  '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$';
  }

  randomString(length: number) {
    const randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for ( let i = 0; i < length; i++ ) {
      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
  }
  // extraer aviso respuesta peticion
  extraerError(e) {
    let aviso = !Array.isArray(e?.data) ? (e.data?.mensaje) ? e.data?.mensaje : 'No especificado' : ' Error ';
    if (Array.isArray(e.data)) {
      e?.data.forEach(element => {
        if (element.id === 999) {
          aviso = ' ' + element.mensaje;
          return;
        }
      });
    }
    return aviso;
  }

  formatearExtensionesFormatos(formatos: string[] = []): string[] {
    // console.log('Formatear ', formatos);
    // debe iniciar con el punto
    if (formatos.length > 0) {
      formatos.map((item, key, array) => {
        // console.log(item, item[0], '.' + item);
        return (item[0] && item[0] != '.') ? array[key] = '.' + item : item;
      })
    }
    // console.log(' ** formatos ', formatos);
    return formatos
  }

}
